/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { SvgIcon } from '@mui/material';

export function WarningIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <path d="M4.47,20 L19.53,20 C21.07,20 22.03,18.33 21.26,17 L13.73,3.99 C12.96,2.66 11.04,2.66 10.27,3.99 L2.74,17 C1.97,18.33 2.93,20 4.47,20 Z M12,13 C11.45,13 11,12.55 11,12 L11,10 C11,9.45 11.45,9 12,9 C12.55,9 13,9.45 13,10 L13,12 C13,12.55 12.55,13 12,13 Z M13,17 L11,17 L11,15 L13,15 L13,17 Z" />
    </SvgIcon>
  );
}
